  <app-site-content key="BeatYourBroker.Thankyou" [appScrollIntoView]="true" showTitle="false"
                    [data]="data">
  </app-site-content>